import { render, staticRenderFns } from "./underlying-income.vue?vue&type=template&id=cdb34e6c&scoped=true&"
import script from "./underlying-income.vue?vue&type=script&lang=js&"
export * from "./underlying-income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb34e6c",
  null
  
)

export default component.exports